import { jsx as _jsx } from "react/jsx-runtime";
import '@styles/webdesktop/stylesheets/timeNumeric.scss';
import { NumericUtils } from '@shared/utils/NumericUtils';
import { NumericContainer } from '../NumericComponents/NumericContainer/NumericContainer';
import { NumericInput } from '../NumericComponents/NumericInput/NumericInput';
import { numericFormatter } from 'react-number-format';
import { TimeScale } from './TimeScale';
export const TimeNumeric = ({ value, type, onValueChange, disabled = false }) => {
    const step = 1;
    const min = 0;
    const max = type === TimeScale.Hours ? 23 : 59;
    const onIncrement = () => {
        const newValue = NumericUtils.valueUpDownChangeProcess(true, value, step, min, max);
        return newValue;
    };
    const onDecrement = () => {
        const newValue = NumericUtils.valueUpDownChangeProcess(false, value, step, min, max);
        return newValue;
    };
    const format = (numStr) => {
        if (numStr === '')
            return '';
        const padded = numStr.length === 1 ? `0${numStr}` : numStr;
        return numericFormatter(padded, {
            allowNegative: false,
            decimalScale: 0,
            fixedDecimalScale: true,
            allowLeadingZeros: true,
            min: min,
            max: max
        });
    };
    return (_jsx(NumericContainer, { className: "time-numeric", disabled: disabled, children: _jsx(NumericInput, { value: value, step: step, onValueChange: onValueChange, min: min, max: max, inputMode: "numeric", format: format, onIncrement: onIncrement, onDecrement: onDecrement, isOnlyMouseWheel: true, allowLeadingZeros: true, allowNegative: false }) }));
};
